import { Encoder } from '@everyboard/lib';
import { Player, PlayerOrNone } from '../../jscaip/Player';
export class DiamPiece {
    owner;
    otherPieceType;
    static encoder = Encoder.tuple([PlayerOrNone.encoder, Encoder.identity()], (piece) => [piece.owner, piece.otherPieceType], (fields) => DiamPiece.of(fields[0], fields[1]));
    static EMPTY = new DiamPiece(PlayerOrNone.NONE, false);
    static ZERO_FIRST = new DiamPiece(Player.ZERO, false);
    static ZERO_SECOND = new DiamPiece(Player.ZERO, true);
    static ONE_FIRST = new DiamPiece(Player.ONE, false);
    static ONE_SECOND = new DiamPiece(Player.ONE, true);
    static PLAYER_PIECES = [
        DiamPiece.ZERO_FIRST,
        DiamPiece.ZERO_SECOND,
        DiamPiece.ONE_FIRST,
        DiamPiece.ONE_SECOND,
    ];
    static of(player, otherPieceType) {
        if (player === Player.ZERO) {
            if (otherPieceType)
                return DiamPiece.ZERO_SECOND;
            return DiamPiece.ZERO_FIRST;
        }
        else if (player === Player.ONE) {
            if (otherPieceType)
                return DiamPiece.ONE_SECOND;
            return DiamPiece.ONE_FIRST;
        }
        return DiamPiece.EMPTY;
    }
    constructor(owner, otherPieceType) {
        this.owner = owner;
        this.otherPieceType = otherPieceType;
    }
    toString() {
        return `DiamPiece(${this.owner}, ${this.otherPieceType})`;
    }
    equals(other) {
        return this === other;
    }
}
